module.exports = __webpack_public_path__ + "static/img/qr_code.4c48a90.jpeg";


//////////////////
// WEBPACK FOOTER
// ./examples/assets/qr_code.jpeg
// module id = EBG1
// module chunks = 1